import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ElioSvgIconsModule } from '@elio/shared/icon-utils';
import { ElioTheme } from '@elio/shared/models';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'elio-button[dataQA]',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  standalone: true,
  imports: [CommonModule, ElioSvgIconsModule, RouterModule, TooltipModule],
  styles: [
    `
      :host-context(.bottom-anchor) {
        button {
          @apply rounded-t-md rounded-b-none;
        }
      }

      :host-context(.small) {
        button {
          @apply py-1 px-2;

          & span {
            @apply text-sm;
          }

          & elio-svg-icon {
            @apply text-base;
          }
        }
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElioButtonComponent {
  @Input() icon?: string;
  @Input() label?: string;
  @Input() type: 'submit' | 'reset' | 'button' = 'button';
  @Input() tooltip?: string;
  @Input() iconRotation = 0;
  @Input() isHidden = false;
  //
  /**
   * Floating Action Button
   * Show only icon and add tooltip label
   */
  @Input() fab = false;

  @Input()
  @HostBinding('class._disabled')
  isDisabled = false;

  @Input()
  @HostBinding('class._loading')
  isLoading = false;

  @Input()
  @HostBinding('attr.data-button-theme')
  theme?: ElioTheme = 'blue';

  @Input() dataQA!: string;

  @Output() readonly onclick = new EventEmitter<void>();

  onClick() {
    if (!this.isDisabled && !this.isLoading && !this.isHidden) {
      this.onclick.emit();
    }
  }
}
